import { render, staticRenderFns } from "./mockup2.vue?vue&type=template&id=d2fdd218&scoped=true"
import script from "./mockup2.vue?vue&type=script&lang=js"
export * from "./mockup2.vue?vue&type=script&lang=js"
import style0 from "./mockup2.vue?vue&type=style&index=0&id=d2fdd218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fdd218",
  null
  
)

export default component.exports